import { gql } from 'graphql-request'

export const QueryFeatureCardBlock = gql`
  fragment FragmentFeatureCardBlock on FeatureCardBlockModelRecord {
  __typename
  id
  title
  icon
  preface
  logo {
    title
    url
    filename
    mimeType
    width
    height
    responsiveImage {
      sizes
      src
      width
      height
      alt
      title
      base64
    }
  }
  description {
    value
    links {
      __typename
      ... on ArticleModelRecord {
        id
        slug
      }
      ... on CustomerModelRecord {
        id
        slug
      }
      ... on PageModelRecord {
        id
        slug
      }
      ... on IntegrationModelRecord { 
      	id
        slug
      }
    }
  }
  image {
    title
    url
    filename
    mimeType
    video {
      muxPlaybackId
      title
      width
      height
      blurUpThumb
    }
    width
    height
    responsiveImage {
      sizes
      src
      width
      height
      alt
      title
      base64
    }
  }
  video {
    title
    url
    filename
    mimeType
    video {
      muxPlaybackId
      title
      width
      height
      blurUpThumb
    }
  }
  featureListItems {
    ...FragmentFormattedTextBlock
  }
  bulletListColor
  action {
    ...FragmentNavigationItem
  }
}
`
